export default __webpack_public_path__ + "static/media/Financial Results.256bc6c2.pdf";